import { useEffect, useState } from "react";
import { getGlobalDistribucion } from "../services/alertasGenericasService";

export const useGlobalDistribucion = (programa, competencia = "RC") => {
  const [puntajes, setPuntajes] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const p = (programa || "").trim();
    if (!p) {
      setPuntajes([]);
      setStats(null);
      setLoading(false);
      return undefined;
    }

    let activo = true;
    setLoading(true);

    getGlobalDistribucion(p, competencia).then((payload) => {
      if (!activo) return;
      setPuntajes(Array.isArray(payload?.puntajes) ? payload.puntajes : []);
      setStats(payload?.stats || null);
      setLoading(false);
    });

    return () => {
      activo = false;
    };
  }, [programa, competencia]);

  return {
    loading,
    puntajes,
    stats,
  };
};
